export const PAYMENT_REQUESTS_TABLE_TITLE = 'ISO Reports';
export const PAYMENT_REQUESTS_TABLE_INFO_URL = '';
